const DATA_UNITS = Object.freeze({
  MB: 'MB',
  GB: 'GB',
  TB: 'TB',
});

export { DATA_UNITS };
